import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";


function getQuery(name) {
  return new URLSearchParams(window.location.search).get(name);
}

export default function CancellationResult() {
  const { t, i18n } = useTranslation("cancel");

  // si ?lang=fr|en|nl est présent, on force la langue de la page
  useEffect(() => {
    const ql = getQuery("lang");
    if (ql && ["fr","en","nl"].includes(ql) && i18n.language.slice(0,2) !== ql) {
      i18n.changeLanguage(ql);
    }
  }, [i18n]);

  const status = getQuery("status"); // missing | not_found | error | undefined

  const title = t("cancelled.title", "Votre inscription a bien été annulée");
  const subtitle = t("cancelled.subtitle", "Nous espérons vous revoir bientôt !");
  const backCta = t("cancelled.book", "Réserver un autre cours");
  const extra =
    status === "not_found" ? t("cancelled.notFound", "Référence introuvable ou déjà annulée.")
    : status === "missing" ? t("cancelled.missing", "Lien invalide.")
    : status === "error"   ? t("cancelled.error", "Une erreur est survenue.")
    : null;

  return (
    <div style={{minHeight:"60vh",display:"grid",placeItems:"center",padding:"24px"}}>
      <div style={{
        width:"100%",maxWidth:640,background:"#111217",border:"1px solid #25263a",
        borderRadius:18,padding:"24px",color:"#e7e7ff"
      }}>
        <div style={{textAlign:"center",padding:"24px 12px"}}>
          <div style={{
            display:"inline-block",padding:"8px 12px",borderRadius:999,
            background:"#7C3AED",color:"#fff",fontWeight:800,marginBottom:10
          }}>
            MKD Studio
          </div>
          <h1 style={{margin:"8px 0 6px"}}>{title}</h1>
          <p style={{margin:"0 0 16px",opacity:.9}}>{subtitle}</p>
          {extra && <p style={{margin:"0 0 12px",opacity:.8}}>{extra}</p>}
          <a href="/horaires" style={{
            display:"inline-block",padding:"14px 20px",borderRadius:12,
            background:"#7C3AED",color:"#fff",fontWeight:700,textDecoration:"none"
          }}>
            {backCta}
          </a>
        </div>
      </div>
    </div>
  );
}
